import * as ProductCards from "../modules/productCards";
//import * as CollectionGrid from "../modules/collectionGrid";

namespace NHW.controllers.productListing {
	export function init() {
		ProductCards.init();
		//CollectionGrid.init();
	}
}

NHW.controllers.productListing.init();
